import React, { Component } from 'react';
import './TopTeaser.css';
class TopTeaser extends Component {
	render() {
		return (
			<div className='TopTeaser'>
				<p className='TopTeaserInfo'>
					Vi har læst alle anmeldelserne og vi holder løbende øje med nye restauranter.
					Vi kan derfor præsenterer dig for Københavns 100 bedste restauranter.
				</p>
			</div>
		);
	}
}

export default TopTeaser;



// WEBPACK FOOTER //
// ./src/components/elements/TopTeaser.js